var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTechTableApplicationsMan = function SvgTechTableApplicationsMan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480.1 182.3",
    enableBackground: "new 0 0 480.1 182.3",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tech_table_applications_man") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29526B",
    d: "M240.1,45.6c6.2,0,11.3-5,11.3-11.3c0-6.2-5-11.3-11.3-11.3s-11.3,5-11.3,11.3c0,0,0,0,0,0 C228.8,40.6,233.8,45.6,240.1,45.6C240.1,45.6,240.1,45.6,240.1,45.6z M251.9,48.1H228c-8,0-14.5,6.6-14.4,14.6c0,0,0,0.1,0,0.1 v34.7c0,6.7,9.9,6.7,9.9,0V65.7h2.3v86.8c0,9,13.1,8.7,13.1,0v-50.4h2.3v50.4c0,8.7,13.2,9,13.2,0V65.7h2.3v31.7 c-0.1,2.7,2,5,4.7,5.1s5-2,5.1-4.7c0-0.1,0-0.3,0-0.4V63C266.6,54.9,260.1,48.2,251.9,48.1C251.9,48.1,251.9,48.1,251.9,48.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 480.1,
    height: 182.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTechTableApplicationsMan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tech_table_applications_man.b9b35436f4393dca07e54982f0a78dcf.svg";